import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch } from '@ff-scene-plugins/photo-prints-redux/store';
import classNames from 'classnames';
import { ChangeVariantWindow } from '../../change-variant-window/ChangeVariantWindow';
import { PhotoPrintCropModal } from '../../photo-print/photo-print-crop/PhotoPrintCropModal';
import styles from './PhotoPrintDesktopOverlay.module.scss';

const _PhotoPrintDesktopOverlay = ({ className, photoId, removePhoto }: Props) => {

    const { t } = useTranslation();
    const [isVariantModalOpen, setIsVariantModalOpen] = useState(false);
    const [isCropModalOpen, setIsCropModalOpen] = useState(false);

    return (
        <>
            <div onClick={() => setIsCropModalOpen(true)}
                className={classNames(styles.edit, styles.button, className)}>
                <Icon type='general-ui-brush' size='small' />
            </div>

            <div onClick={removePhoto}
                className={classNames(styles.remove, styles.button, className)}>
                <Icon type='general-ui-bin' size='small' />
            </div>

            <div onClick={() => setIsVariantModalOpen(true)}
                className={classNames(styles.variant, styles.button, className)}>
                {t('photo_prints.change_variant')}
            </div>

            {isVariantModalOpen && (
                <WindowStackItem>
                    <ChangeVariantWindow withMethod
                        close={() => setIsVariantModalOpen(false)}
                        photoId={photoId} />
                </WindowStackItem>
            )}

            {isCropModalOpen && (
                <WindowStackItem>
                    <PhotoPrintCropModal
                        isOpen={isCropModalOpen}
                        close={() => setIsCropModalOpen(false)}
                        photoId={photoId} />
                </WindowStackItem>
            )}
        </>
    );
};

type OwnProps = {
    photoId: string;
};

type Props = OwnProps & {
    className: string;
    removePhoto: () => void;
};

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({
    removePhoto: () => dispatch(photoActions.remove(ownProps.photoId))
});

export const PhotoPrintDesktopOverlay = connect(
    null,
    mapDispatchToProps
)(_PhotoPrintDesktopOverlay);